<template>
  <div style="height: fit-content;position:relative;width: 100%">
    <video style="width: 100%" controls
           v-if="show_video"
           crossorigin="*"

           playsinline :poster="image_cover" id="player" >
      <!-- Video files -->
      <!--    <source  v-for="source in video_link" :src="source.link" type="video/mp4" size="576">-->

      <!-- Caption files -->
      <!--    <track  v-for="subtitle in subtitles" kind="captions" :label="subtitle.name" srclang="en"-->
      <!--           :src="subtitle.file"-->
      <!--           default>-->

      <!-- Fallback for browsers that don't support the <video> element -->
      <!--    <a href="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4" download>Download</a>-->
    </video>
<div class="banner-advertise" v-if="(banner_advertise!=null && banner_advertise.length>0) && (show_banner_ads && !disable_banner_ads)" >
  <div class="data-banner">
    <div @click="disable_banner_ads=true" class=" close-ads">
      x
    </div>
<div>
  <a v-if="banner_advertise!=null && banner_advertise.length>0" :href="banner_advertise[0].landing_url" target="_blank">
    <img :src="banner_advertise[0].video_url" width="100%" />
  </a>
</div>
  </div>
</div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'VideoPlayer',
  components: {},
  data() {
    return {
      show_banner_ads:false,
      disable_banner_ads:false,
      show_video:true,
      video_player: null,
      in_advertise: false,
      all_advertise:[],
      video_link_mutate:[],
      last_visit_ads_time: 60,//60 min after last visit advertise
    }
  },
  props: {
    video_duration:Number,
    image_cover: String,
    video_link: Array,
    subtitles: Array,
    advertise: Array,
    banner_advertise: Array,
    poster_id: String,
    in_buy:Number,//0=free //1=not buy //2=buyed
    teaser: null,

    episode_id: String,
  },
  created() {
  }, mounted() {
    this.all_advertise = [];
    // this.all_advertise = JSON.parse(JSON.stringify(this.advertise));
    this.video_link_mutate = JSON.parse(JSON.stringify(this.video_link));
if(this.banner_advertise!=null && this.banner_advertise.length>0){
  this.show_banner_ads = true
}
    this.config_player();
  },
  watch: {},
  methods: {
    config_player() {

      var self = this;
      if ($('#player').length) {
        self.video_player = new Plyr('#player');

        //check last ads visit
        // var obj_last_visit = localStorage.getItem("last_ads_visit")
        // if (obj_last_visit != null && obj_last_visit != '') {
        //   obj_last_visit = JSON.parse(obj_last_visit);
        //   var date = new Date(obj_last_visit.date);
        //   var date_now = new Date()
        //
        //   // console.log("compare date = ", date, date_now, ((date_now - date)/60000))
        //   if (((date_now - date) / 60000) < this.last_visit_ads_time) {
        //     // console.log("last visit is soon and ads not show")
        //     self.all_advertise = []
        //   }
        // }
//check its sell item
//           console.log("in buy is",self.in_buy,self.teaser)
//         if(self.in_buy != 0){
          self.all_advertise = []
//           if(self.in_buy==1){
//             self.video_link_mutate = [{link:self.teaser.link}]
//           }
//         }


        var player_div = document.getElementById('player')

        if (this.all_advertise.length > 0) {
          var advertise_child = document.createElement("source");
          advertise_child.src = this.all_advertise[0].video_url;
          advertise_child.type = "video/mp4"
          advertise_child.size = "576"
          advertise_child.id = "advertise_vid"
          self.in_advertise = true

          player_div.appendChild(advertise_child);
          player_div.controls = false



          player_div.addEventListener('ended', function () {
            advertise_child.remove();

            self.play_video()



          }, false);


        } else {

          self.play_video()
        }


        self.video_player.config.isAds = self.in_advertise
        if(self.in_advertise){
          self.video_player.config.AdsUrl = this.all_advertise[0].landing_url
        }

      } else {
        return false;
      }
      return false;

    },
    play_video(){
      var player_div = document.getElementById('player')
      var self = this
      player_div.addEventListener("pause", (event) => {
        // console.log("pause video")
        self.show_banner_ads = true
      });
      player_div.addEventListener("play", (event) => {
        // console.log("play video")
        self.show_banner_ads = false

      });

      var self = this
      self.video_link_mutate.forEach(function (val) {
        //
        //   var advertise_child = document.createElement("source");
        //   advertise_child.src = val.link
        //   advertise_child.type = "video/mp4"
        //   advertise_child.size = "576"
        //   advertise_child.id = "advertise_vid"
        //   self.in_advertise = false
        //
        //   player_div.appendChild(advertise_child);
        if(val.link.includes("m3u8")) {
          if (Hls.isSupported()) {
            self.show_video = true;
            var config = {
              debug: false,
            };
            var hls = new Hls(config);
            fetch(val.link)
              .then(response => {
                //handle response
                return response.blob();

              })
              .then(blob => {
                //handle data
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function() {
                  var base64data = reader.result;
                  var base64 = base64data.split(',')[1];
                  var decoded = atob(atob(base64));
                  var enc = new TextEncoder("utf-8");
                  var duration = 0;

                  var baseurl = val.link.replace('video.m3u8',"");
                  var lines = decoded.split(/[\r\n]/);
                  for (var i in lines){
                    var line = lines[i];
                    if(line.includes(".vhm")){
                      decoded = decoded.replace(line,baseurl+line);
                    }
                    if(line.startsWith("#EXTINF")){
                      let dur_line = line
                      dur_line= dur_line.replace("#EXTINF:","");
                      dur_line= dur_line.replace(",","");
                      duration+=parseFloat(dur_line)
                    }
                    // }
                  }
                  // console.log("duration is decode",duration)
                  self.$emit('update:video_duration',duration)
                  self.$emit('video_duration',duration)

                  // console.log("decoded",decoded)
                  hls.loadSource(URL.createObjectURL(new Blob([enc.encode(decoded)])));
                  // hls.loadSource((blob));
                  hls.attachMedia(player_div);
                  hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                    video.muted = false;
                    // video.play();
                  });

                }

                // console.log(data);
              })
              .catch(error => {
                //handle error
              });

          }
          else if (player_div.canPlayType('application/vnd.apple.mpegurl')) {
            // player_div.src = val.link;
            fetch(val.link)
              .then(response => {
                //handle response
                return response.blob();

              })
              .then(blob => {
                //handle data
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function() {
                  var base64data = reader.result;
                  var base64 = base64data.split(',')[1];
                  var decoded = atob(atob(base64));
                  var enc = new TextEncoder("utf-8");
                  var duration = 0;
                  var baseurl = val.link.replace('video.m3u8',"");
                  var lines = decoded.split(/[\r\n]/);
                  for (var i in lines){
                    var line = lines[i];
                    if(line.includes(".vhm")){
                      decoded = decoded.replace(line,baseurl+line);
                    }
                    if(line.startsWith("#EXTINF")){
                      let dur_line = line
                      dur_line= dur_line.replace("#EXTINF:","");
                      dur_line= dur_line.replace(",","");
                      duration+=parseFloat(dur_line)
                    }
                    // }
                  }
                  // console.log("duration is decode",duration)
                  self.$emit('update:video_duration',duration)
                  self.$emit('video_duration',duration)

                  const blob = new Blob([enc.encode(decoded)], { type: 'application/x-mpegURL' });
                  const blobURL = URL.createObjectURL(blob);

                  player_div.setAttribute('controls', true);

                  const sourceElement = document.createElement('source');

                  player_div.appendChild(sourceElement);

                  sourceElement.src = blobURL;
                  sourceElement.type = 'application/x-mpegURL';


                }

                // console.log(data);
              })
              .catch(error => {
                alert("error",error)
              });

          }
        }

      })
      self.subtitles.forEach(function (val) {
        var advertise_child = document.createElement("track");
        advertise_child.src = val.file
        advertise_child.kind = "captions"
        advertise_child.srclang = "en"
        advertise_child.label = val.name
        player_div.appendChild(advertise_child);
      })
      self.in_advertise = false
      self.video_player.config.isAds = false
      self.video_player.config.AdsUrl = ""

      // player_div.load();
      player_div.controls = true
      // player_div.play();


      self.view_video()
    },
    view_advertise() {
      var self = this;
      const formData = new FormData();
      var url = "view_advertise";
      var profile = localStorage.getItem("login_info");
      if (profile != null && profile != '') {
        formData.append('token', profile);
      }
      formData.append('ads_id', this.all_advertise[0].ads_id);
      formData.append('poster_id', this.poster_id);

      axios.post(url, formData, {}).then(function (response) {
        var obj_last_visit = {
          date: new Date(),
          id: self.advertise[0].ads_id,
        }
        localStorage.setItem("last_ads_visit", JSON.stringify(obj_last_visit))
      })
        .catch(function (error) {

          console.log(error);
        });

    },
    view_video() {
      var self = this;
      const formData = new FormData();
      var url = "view_video";
      var profile = localStorage.getItem("login_info");
      if (profile != null && profile != '') {
        formData.append('token', profile);
      }
      formData.append('guid', localStorage.getItem("user_guid"));

      // formData.append('ads_id', this.all_advertise[0].ads_id);
      formData.append('poster_id', this.poster_id);

      if (this.poster_id != this.episode_id) {
        formData.append('episode_id', this.episode_id);
      }

      axios.post(url, formData, {}).then(function (response) {


      })
        .catch(function (error) {

          console.log(error);
        });

    },
  }
}
</script>
